import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { ReminderFrequencyEnum } from 'src/app/_models';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';

@Component({
    selector: 'formly-reminder-frequency-input',
    templateUrl: './formly-reminder-frequency-input.component.html',
    standalone: false
})
export class FormlyReminderFrequencyInputComponent extends FieldType implements OnInit, OnDestroy {

    ReminderFrequencyEnum = ReminderFrequencyEnum;
    fieldKey: string;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;

    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    selectFrequency(frequency: number) {
        this.formControl.setValue(frequency);
        this.onValueChange();
    }

    onValueChange() {
        if (this.to.change) {
            this.to.change(this.field, this.formControl.value);
        }
    }
}
